import { useEffect } from 'react';

//const NEW_OPTION = '--NEW_OPTION--'; // Or your specific constant

export const useSyncCustomOption = (
  customText: string | null,
  setOptions: React.Dispatch<React.SetStateAction<any[]>>,
  options: any[],
  newOptionValue: string = "--new-option--",
) => {
  useEffect(() => {
    if (!customText) return;

    // Check if the label already exists in the current options list
    const labelExists = options.some(x => x.label === customText);

    if (!labelExists) {
      setOptions(prev => {
        const hasNewOption = prev.some(x => x.value === newOptionValue);

        if (hasNewOption) {
          // Update the existing NEW_OPTION label
          return prev.map(item =>
            item.value === newOptionValue ? { ...item, label: customText } : item
          );
        } else {
          // Append a brand new option
          return [...prev, { value: newOptionValue, label: customText }];
        }
      });
    }
  }, [customText]); // Logic runs whenever the text changes
};